import { getPutSchedulerSettingsUrl } from '@dashhudson/api-client/scheduler/client';

import type { HttpRequestConfig } from '@/types/http';

import { http } from '@/apis/scheduler';

export interface QueueSettings {
  brandId: number;
  queuePaused: boolean;
}

export interface UpdateQueueSettingsRequest {
  brandId: number;
  queuePaused: boolean;
}

// Returns queuePaused: false when the brand has no settings row.
export async function getQueueSettings(
  { brandId }: { brandId: number },
  config: HttpRequestConfig = {},
) {
  return http.get<QueueSettings>('/scheduler-settings', { ...config, params: { brandId } });
}

// Brand admin only.
export async function updateQueueSettings(
  { brandId, queuePaused }: UpdateQueueSettingsRequest,
  config: HttpRequestConfig = {},
) {
  return http.put(getPutSchedulerSettingsUrl(), { brandId, queuePaused }, config);
}
